import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import NavHeader from "../../components/layout/NavHeader";
import data_main_menu from '../../data/jsons/main_menu.json';
import {Context} from "../../context/Wrapper";
import {LANG_EN} from "../../constants";

const HeaderLayout = (props) => {
    const context = useContext(Context)

    const [headerMenu] = useState(data_main_menu.main_menu)
    const [headerMenuId] = useState(data_main_menu.main_menu_id)

    const [state, setState] = useState({
        done: false
        , public_header_menus: []
        , public_header_sub_menus: []
        , product_sub_categories: []
        , product_categories: []
        , setting: []
    });

    useEffect(() => {
        const fetchData = async () => {
            const header = {headers: {'language': context.locale}};
            const product_categories = await axios.get('product_categories', header);
            const product_sub_categories = await axios.get('product_sub_categories', header);
            const setting = await axios.get('setting', header);
            setState({
                done: true
                , product_categories: product_categories.data.product_categories
                , product_sub_categories: product_sub_categories.data.product_sub_categories
                , setting: setting.data
            });

        }
        fetchData().catch(e => (e.message));
    }, [context.locale]);

    return (
        <>
            <NavHeader
                dataMenu={context && context.locale === LANG_EN ? headerMenu : headerMenuId}
                dataSubMenu={state.public_header_sub_menus}
                product_categories={state.product_categories}
                product_sub_categories={state.product_sub_categories}
                setting={state.setting}
                done={state.done}
                selectLang={props.selectLang}
            />
        </>
    )
}

export default React.memo(HeaderLayout)